/** Text stored in both languages (course titles, category names…). */
export interface LocalizedText {
  ar?: string | null;
  en?: string | null;
}

/**
 * The text in the reader's language, falling back to the other one so a
 * course with only an Arabic title still shows something in English.
 */
export function localized(
  text: LocalizedText | null | undefined,
  lng: string
): string {
  if (!text) return '';
  const own = lng === 'en' ? text.en : text.ar;
  const other = lng === 'en' ? text.ar : text.en;
  return (own || other || '').trim();
}
